
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import DeletePopup from '../../GardenPopup/DeletePopup'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import WTPEquipmentTypeMasterPagePopup from './WTPEquipmentTypeMasterPagePopup'
import { WTPEquipmentTypeDDLData } from '../../../../../Components/CommonDDL/WTPEquipmentTypeDDLData'
import { WTPEquipmentTypeDeleteAPI, WTPEquipmentTypeTableDataAPI } from '../../../../../Redux/WTPDashboardSlice/WTPSidebarSlice/EquipmentTypeSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../../../../Helper/Context'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../Helper/Loading'

export default function WTPEquipmentTypeMasterPage() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [WaterQualityPhPopupShow, setWaterQualityPhPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WTPEquipmentTypeMasterPagePopupShow, setWTPEquipmentTypeMasterPagePopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [WtpEquipmentType, setWtpEquipmentType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWTPEquipmentTypeMasterPagePopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setWTPEquipmentTypeMasterPagePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setWTPEquipmentTypeMasterPagePopupShow(false)
    }

    const handleIsSearch = () => {
        setIsSearch(!isSearch)
        setCurrentPage(0)
    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
    }


    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)

        setWtpEquipmentType({
            ...WtpEquipmentType,
            ID: 0,
            Label: 'Select...',
        })
    }

    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,      
            M_WTP_EquipmentTypeID: WtpEquipmentType.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,

        }
        dispatch(WTPEquipmentTypeTableDataAPI({ data }))

    }, [IsPost, To, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.WTPEquipmentTypeTableData)

    const handleDeleteApi = (item) => {
        const data = {
            M_WTP_EquipmentTypeID: item.m_wtP_EquipmentTypeID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
        }
        dispatch(WTPEquipmentTypeDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WTPEquipmentTypeDeleteData)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar
                    ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId}
                    active='wtpequipmenttypemasterpage'
                    listActive="wtpmaster" />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Equipment Type Master</h5>
                                <div className="float-end butt">
                                    {/* <button type="button" className="btn btn-primary float-end ml-1">Export</button> */}
                                    <i className="fa-solid fa-plus float-end btn btn-secondary"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-3 col-md-6">
                                                <WTPEquipmentTypeDDLData
                                                    WtpEquipmentType={WtpEquipmentType}
                                                    setWtpEquipmentType={setWtpEquipmentType}                                             
                                                />
                                            </div>
                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleIsSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-3">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Equipment Type</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.equipmentType ? item.equipmentType : '-'}</td>

                                                                <td style={{ textAlign: "center", width: '7%' }}>

                                                                    <span >

                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </span>


                                                                </td>

                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }

                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WTPEquipmentTypeMasterPagePopupShow ?
                        <WTPEquipmentTypeMasterPagePopup
                            open={WTPEquipmentTypeMasterPagePopupShow}
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div >



    )
}